import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Alert, Box, Select, MenuItem, Backdrop, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiInput from "components/SuiInput";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";

//import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//import { TimePicker } from "@mui/x-date-pickers/TimePicker";
//import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//import dayjs from "dayjs";
//import "dayjs/locale/es";

// Soft UI Dashboard React example components
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";

import dayjs from "dayjs";
import "dayjs/locale/es";
import weekday from "dayjs/plugin/weekday";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(weekday);
dayjs.extend(isSameOrBefore);

import useUserRoles from "hooks/useUserRoles";

import DatosBasicosApi from "api/datosbasicosApi";
import ProcesosApi from "api/procesosApi";
import BucketApi from "api/bucketApi";
import PDFApi from "api/pdfApi";

const Admitir = () => {
  const { user, roles } = useUserRoles();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(undefined);
  const [proceso, setProceso] = useState(null);
  const [autoAdmision, setAutoAdmision] = useState("");
  const [obserAdmision, setObserAdmision] = useState("");
  const [fechaAdmision, setFechaAdmision] = useState("");
  const [fechaAudiencia, setFechaAudiencia] = useState("");
  const [horaAudiencia, setHoraAudiencia] = useState("");
  const [modalidadAudiencia, setModalidadAudiencia] = useState("");
  const [zoomAudiencia, setZoomAudiencia] = useState("");
  const [salasZoom, setSalasZoom] = useState([]);
  const [lugarAudiencia, setLugarAudiencia] = useState("");
  const [diasFestivos, setDiasFestivos] = useState([]);
  const [saving, setSaving] = useState(false);
  const { identificador } = useParams();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const origen = queryParams.get("origen");
  const FILE_NAME = "pdf_admision.pdf";
  const ANEXO_TYPE = "PDF_ADMISION";

  const fetchInitialData = async () => {
    try {
      setSaving(true);
      const diasFestivosResp = await DatosBasicosApi.fetchDiasFestivos();
      setDiasFestivos(Array.isArray(diasFestivosResp.data) ? diasFestivosResp.data : []);
      try {
        const salasZoomResp = await DatosBasicosApi.fetchSalasZoomActivas();
        setSalasZoom(Array.isArray(salasZoomResp.data) ? salasZoomResp.data : []);
      } catch (errorSalas) {
        console.error("Error al obtener las salas Zoom:", errorSalas);
        setError(obtenerMensajeError(errorSalas, "Error al cargar las Salas Zoom."));
      }
      const respProceso = await ProcesosApi.fetchProcesoByIdentificador(identificador);
      //alert("respProceso: " + JSON.stringify(respProceso.data));
      if (respProceso.data) {
        setProceso(respProceso.data);
        if (respProceso.data.auto_admision) {
          setAutoAdmision(respProceso.data.auto_admision);
        } else {
          const response = await ProcesosApi.obtenerAutoAdmision();
          //alert("response: " + JSON.stringify(response));
          if (response.status === 200 && response.data) {
            setAutoAdmision(response.data.auto_admision);
          }
        }
      }
    } catch (error) {
      console.error("Error al obtener los datos iniciales:", error);
      setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (identificador) {
      fetchInitialData();
    }
  }, [user, identificador]);

  useEffect(() => {
    const fechaActual = new Date().toLocaleString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    setFechaAdmision(fechaActual);
  }, [identificador]);

  useEffect(() => {
    const validarDisponibilidadEnTiempoReal = async () => {
      if (proceso?.resp_operador && fechaAudiencia && horaAudiencia) {
        const disponibilidad = await verificarDisponibilidadOperador();
        if (!disponibilidad.disponible) {
          // Mostrar una advertencia visual (no bloquear)
          console.warn("Operador no disponible:", disponibilidad.mensaje);
          setError("El (la) Operador(a) no esta disponible para ese espacio de tiempo.");
        } else {
          setError(undefined);
        }
      }
    };
    // Validar cada vez que cambien fecha u hora
    const timeoutId = setTimeout(validarDisponibilidadEnTiempoReal, 1000);
    return () => clearTimeout(timeoutId);
  }, [fechaAudiencia, horaAudiencia, proceso?.resp_operador?.id]);

  const handleSelectChange = (e) => {
    if (e.target.name === "modalidadAudiencia") {
      setModalidadAudiencia(e.target.value);
    }
    if (e.target.name === "zoomAudiencia") {
      setZoomAudiencia(e.target.value);
    }
  };

  const isNonWorkingDay = (date) => {
    return (
      dayjs(date).day() === 0 ||
      dayjs(date).day() === 6 ||
      diasFestivos?.includes(dayjs(date).format("YYYY-MM-DD"))
    );
  };

  const verificarDisponibilidadOperador = async () => {
    if (!proceso?.resp_operador || !fechaAudiencia || !horaAudiencia) {
      return { disponible: false, mensaje: "Faltan datos para verificar disponibilidad" };
    }
    try {
      const response = await ProcesosApi.verificarDisponibilidadOperador({
        operador_id: proceso.resp_operador,
        fecha_audiencia: fechaAudiencia,
        hora_audiencia: horaAudiencia,
      });
      return response.data;
    } catch (error) {
      console.error("Error al verificar disponibilidad:", error);
      return {
        disponible: false,
        mensaje: "Error al verificar disponibilidad del operador",
      };
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validaciones
    if (proceso.resp_operador == null || proceso.resp_operador === "") {
      setError(
        "El Proceso no tiene un Operador(a) de Insolvencia registrado por ende no podemos continuar con su Admisión."
      );
      return;
    }
    if (autoAdmision == null || autoAdmision === "") {
      setError("Debes registrar un Auto de Admisión.");
      return;
    }
    if (
      fechaAudiencia == null ||
      fechaAudiencia === "" ||
      horaAudiencia == null ||
      horaAudiencia === ""
    ) {
      setError("Debes registrar la Fecha y Hora de la Audiencia.");
      return;
    }
    if (modalidadAudiencia == null || modalidadAudiencia === "") {
      setError("Debes registrar una Modalidad de la Audiencia.");
      return;
    }
    if (modalidadAudiencia === "Virtual" && (zoomAudiencia == null || zoomAudiencia === "")) {
      setError("Debes registrar un Zoom para la Audiencia.");
      return;
    }
    if (modalidadAudiencia === "Presencial" && (lugarAudiencia == null || lugarAudiencia === "")) {
      setError("Debes registrar un Lugar para la Audiencia.");
      return;
    }
    // Verificar que la nueva fecha sea un día hábil
    if (isNonWorkingDay(fechaAudiencia)) {
      alert(
        "La nueva fecha de audiencia no puede ser en un día no hábil (sábado, domingo o festivo)."
      );
      return;
    }
    //console.log("AUTORIZAR.datos: " + JSON.stringify(datos));
    setLoadingSubmit(true);
    setError(null);
    console.log("Verificando disponibilidad del operador...");
    const disponibilidad = await verificarDisponibilidadOperador();
    if (!disponibilidad.disponible) {
      setLoadingSubmit(false);
      // Mostrar mensaje detallado de conflictos
      let mensajeError = disponibilidad.mensaje;
      if (disponibilidad.conflictos && disponibilidad.conflictos.length > 0) {
        mensajeError += "\nEventos en conflicto:";
        disponibilidad.conflictos.forEach((conflicto, index) => {
          mensajeError += `\n${index + 1}. ${conflicto.title} (${conflicto.start_time} - ${
            conflicto.end_time
          })`;
        });
      }
      // Usar confirm para dar opción al usuario
      const continuar = window.confirm(
        `⚠️ CONFLICTO DE HORARIO ⚠️\n${mensajeError}\n\n¿Desea continuar de todas formas? Esto podría causar conflictos de agenda.`
      );
      if (!continuar) {
        return; // El usuario decidió no continuar
      }
    }
    setSuccessMessage(null);
    const confirmacion = window.confirm("¿Está seguro(a) de admitir el proceso?");
    if (!confirmacion) return;
    try {
      setSaving(true);
      const datos = {
        operacion: "ADMITIR_PROCESO",
        id_proceso: proceso.id,
        auto_admision: autoAdmision,
        obser_admision: obserAdmision,
        fecha_audiencia: fechaAudiencia,
        hora_audiencia: horaAudiencia,
        modalidad_audiencia: modalidadAudiencia,
        zoom_audiencia: zoomAudiencia,
        lugar_audiencia: lugarAudiencia,
      };
      const response = await ProcesosApi.operarProceso(datos);
      if (response.status === 201 && response.data) {
        //const urlResponse = await BucketApi.getProcesoFileUrl(FILE_NAME, proceso.identificador);
        const urlResponse = await BucketApi.getProcesoFileUrlFresh(
          FILE_NAME,
          proceso.identificador
        );
        if (urlResponse.data.file_url) {
          const anexoResponse = await ProcesosApi.obtenerAnexoProcesoByTipo(proceso.id, {
            tipo_anexo: ANEXO_TYPE,
          });
          const anexo = anexoResponse.data;
          if (anexo != undefined && !anexoResponse.data.error) {
            await ProcesosApi.eliminarAnexoProceso(proceso.id, anexo.id);
          }
        }
        // Generar el PDF_ADMISION
        const pdfResponse = await PDFApi.generateDocument("admisionProceso", proceso.id);
        const pdfBlob = new Blob([pdfResponse.data], { type: "application/pdf" });
        const formData = new FormData();
        formData.append("file", pdfBlob, FILE_NAME);
        formData.append("file_type", "proceso");
        formData.append("proceso_id", proceso.identificador);
        formData.append("registrar_anexo", "true");
        formData.append("tipo_anexo", ANEXO_TYPE);
        formData.append("nombre_anexo", "Admisión Proceso");
        await BucketApi.uploadFile(formData);
        setSuccessMessage("El Proceso ha sido admitido correctamente.");
        setTimeout(() => {
          if (origen === "bandeja") {
            history.push(`/procesos/bandeja`);
          } else {
            history.push(`/procesos/consultar`);
          }
        }, 5000); // espera 5 segundos antes de redireccionar
      }
    } catch (error) {
      console.error(`Error al Admitir el Proceso:`, error);
      setError(`Error al Admitir el Proceso.`);
    } finally {
      setLoadingSubmit(false);
      setSaving(false);
    }
  };

  const handleVolver = () => {
    if (origen === "bandeja") {
      history.push(`/procesos/bandeja`);
    } else {
      history.push(`/procesos/consultar`);
    }
  };

  {
    loadingSubmit && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255,255,255,0.7)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {saving && (
        <Backdrop open={true} style={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox
          sx={{
            maxWidth: "80%", // Limita el ancho del formulario
            margin: "auto", // Centra horizontalmente
            backgroundColor: "white", // Asegura que tenga fondo si es necesario
            p: 3, // Agrega padding interno
            borderRadius: "8px", // Bordes redondeados
            boxShadow: 3, // Agrega una sombra sutil
          }}
        >
          <Grid spacing={2}>
            <form onSubmit={handleSubmit}>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <SuiBox>
                  <strong>
                    ADMISIÓN PROCESO: {identificador ? identificador : "No tiene Proceso"}
                  </strong>
                </SuiBox>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }} sx={{ mb: 2 }}>
                <Grid size={6}>
                  <Box display="flex" alignItems="center">
                    <strong>DEUDOR:</strong>
                    <SuiTypography variant="h6" fontWeight="light" sx={{ ml: 2 }}>
                      {proceso?.cliente_detalle.nombre_completo?.toUpperCase() || "No tiene Deudor"}
                    </SuiTypography>
                  </Box>
                </Grid>
                <Grid size={6}>
                  <Box display="flex" alignItems="center">
                    <strong>OPERADOR(A):</strong>
                    <SuiTypography variant="h6" fontWeight="light" sx={{ ml: 2 }}>
                      {proceso?.resp_operador_detalle.nombre_completo?.toUpperCase() ||
                        "No tiene Operador(a)"}
                    </SuiTypography>
                  </Box>
                </Grid>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <Grid size={12}>
                  {error && <Alert severity="error">{error}</Alert>}
                  {successMessage && <Alert severity="success">{successMessage}</Alert>}
                </Grid>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <Grid size={4}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Auto Admisión *
                  </SuiTypography>
                </Grid>
                <Grid size={8}>
                  <SuiBox mb={1} display="flex" alignItems="center" gap={1}>
                    <SuiTypography variant="h6" fontWeight="light">
                      AUTO_No_
                    </SuiTypography>
                    <SuiInput
                      name="autoAdmision"
                      placeholder="Ingrese sólo el Consecutivo"
                      value={autoAdmision || ""}
                      onChange={(event) => {
                        setAutoAdmision(event.target.value);
                        setError(undefined);
                      }}
                      sx={{ flex: 1 }} // Esto permite que el input ocupe el espacio disponible
                    />
                  </SuiBox>
                </Grid>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <Grid size={4}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Obser. Admisión
                  </SuiTypography>
                </Grid>
                <Grid size={8}>
                  <SuiBox mb={1}>
                    <SuiInput
                      name="obserAdmision"
                      placeholder="Ingrese Observación de Admisión"
                      multiline
                      rows={4}
                      value={obserAdmision || ""}
                      onChange={(event) => {
                        setObserAdmision(event.target.value);
                        setError(undefined);
                      }}
                      fullWidth
                    />
                  </SuiBox>
                </Grid>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <Grid size={4}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Fecha Admisión
                  </SuiTypography>
                </Grid>
                <Grid size={8}>
                  <SuiBox mb={1}>
                    <SuiInput
                      name="fechaAdmision"
                      label="Fecha de Admisión"
                      value={fechaAdmision}
                      fullWidth
                      disabled
                      readOnly
                    />
                  </SuiBox>
                </Grid>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <SuiBox mt={1}>
                  <strong>Información de la 1era Audiencia</strong>
                </SuiBox>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <Grid size={4}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Fecha y Hora *
                  </SuiTypography>
                </Grid>
                <Grid size={4}>
                  <SuiBox mb={1}>
                    <SuiInput
                      fullWidth
                      type="date"
                      name="fechaAudiencia"
                      value={fechaAudiencia}
                      onChange={(e) => setFechaAudiencia(e.target.value)} // Guarda solo la fecha en formato YYYY-MM-DD
                      InputLabelProps={{ shrink: true }}
                      //required
                    />
                  </SuiBox>
                </Grid>
                <Grid size={4}>
                  <SuiBox mb={1}>
                    <SuiInput
                      fullWidth
                      type="time"
                      name="horaAudiencia"
                      value={horaAudiencia}
                      onChange={(e) => setHoraAudiencia(e.target.value)} // Guarda solo la hora en formato HH:mm
                      InputLabelProps={{ shrink: true }}
                      //required
                    />
                  </SuiBox>
                </Grid>
              </Grid>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
                <Grid size={4}>
                  <SuiTypography variant="h6" fontWeight="light">
                    Modalidad *
                  </SuiTypography>
                </Grid>
                <Grid size={4}>
                  <Select
                    name="modalidadAudiencia"
                    value={modalidadAudiencia}
                    onChange={handleSelectChange}
                    fullWidth
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Seleccione una Modalidad</em>
                    </MenuItem>
                    <MenuItem value="Presencial">Presencial</MenuItem>
                    <MenuItem value="Virtual">Virtual</MenuItem>
                  </Select>
                </Grid>
                {modalidadAudiencia === "Virtual" && (
                  <Grid size={4}>
                    <Select
                      name="zoomAudiencia"
                      value={zoomAudiencia}
                      onChange={handleSelectChange}
                      fullWidth
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>Seleccione un Zoom</em>
                      </MenuItem>
                      {salasZoom.map((sala) => (
                        <MenuItem key={sala.codigo} value={sala.codigo}>
                          {sala.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                )}
                {modalidadAudiencia === "Presencial" && (
                  <Grid size={4}>
                    <SuiInput
                      name="lugarAudiencia"
                      placeholder="Lugar de la Audiencia Presencial"
                      value={lugarAudiencia}
                      onChange={(event) => {
                        setLugarAudiencia(event.target.value);
                        setError(undefined);
                      }}
                      sx={{ flex: 1 }} // Esto permite que el input ocupe el espacio disponible
                    />
                  </Grid>
                )}
              </Grid>
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", justifyContent: "center", mt: 3 }} // Centrar los botones y dar margen arriba
              >
                <SuiButton
                  variant="contained"
                  color="transparent"
                  sx={{ mr: 2 }} // Espacio a la derecha
                  onClick={handleVolver}
                >
                  Volver
                </SuiButton>
                {(roles.isAdmin || roles.isCoordinador || roles.isOperador || roles.isDirector) && (
                  <SuiButton
                    variant="gradient"
                    buttonColor="dark"
                    type="submit"
                    size="small"
                    disabled={loadingSubmit}
                  >
                    {loadingSubmit ? "Admitiendo..." : "Admitir"}
                  </SuiButton>
                )}
              </Grid>
            </form>
          </Grid>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
};

Admitir.propTypes = {
  proceso: PropTypes.object,
};

export default Admitir;
